import {
  ColumnDef,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  InitialTableState,
  SortingState,
  useReactTable,
} from '@tanstack/react-table'
import { useState } from 'react'

interface DataTableProps<TData, TValue> {
  columns: ColumnDef<TData, TValue>[]
  data: TData[]
  initialSorting?: SortingState
  initialState?: InitialTableState
  filterValue?: string
  filterOnChange?: (value: string) => void
}

export function useDataTable<TData, TValue>({
  columns,
  data,
  initialSorting,
  initialState,
  filterValue,
  filterOnChange,
}: DataTableProps<TData, TValue>) {
  const [sorting, setSorting] = useState<SortingState>(initialSorting ?? [])

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    onSortingChange: setSorting,
    onGlobalFilterChange: filterOnChange,
    defaultColumn: {
      size: 0,
      minSize: 0,
      maxSize: Number.MAX_SAFE_INTEGER,
    },
    initialState,
    state: {
      sorting,
      globalFilter: filterValue,
    },
  })

  const hasFooter =
    table
      .getFooterGroups()
      .map((group) =>
        group.headers.map((header) => header.column.columnDef.footer),
      )
      .flat()
      .filter((ea) => ea !== undefined).length > 0

  return { table, columns, hasFooter }
}
